import { IAppState } from '../../../AppModulesWrapper';
import { ECheckServiceStatus } from '../../types/reducers/checkoutInfo';

export function selectIsAutoProlongDisabled(state: IAppState): boolean {
  const {
    checkoutInfo: { status },
  } = state.servicePickerWidget;

  return status === ECheckServiceStatus.pending;
}
